import { RcFile, UploadFile } from "antd/es/upload"

export enum PushActionType {
    open = 'open',
    watch = 'watch'
}
export interface PushAction {
    id?:string,
    type: PushActionType,
    url: string;
}

export interface PushMessage {
    id?:string,
    title: string,
    message: string,
    imageData?: string,
    imageId?: string,
    actions: PushAction[]
    isSilent: boolean
}

export interface Campaign {
    id?: string,
    name: string,
    status?: string,
    pushMessage: PushMessage
    audiences: string[]
    deliverAt: Date | string
    applicationId?:string
    isTestCampaign: boolean
    meta:any
    hidden?: boolean;
}

export interface CampaignDetail {
    id: string,
    name: string,
    pushMessage: PushMessage,
    audiences: Audience[],
    deliverAt: Date | string;
    status: string;
}

export interface Audience {
    id?: string,
    name: string,
    audienceGroups: AudienceGroup[]
    reach?: number
    estimatedReach?: string
}
export interface AudienceGroup {
    type: AudienceGroupType,
    filters: AudienceGroupFilter[]
}

export interface AudienceGroupFilter {
    type:AudienceFilterType,
    fieldName: string,
    string_value?:string,
    num_value?:number,
    fileName?:string,
    file_dataUri?:string|File
    fileId?:string,
    meta:any
    file: FileReference

}
export interface FileReference {
    id:string,
    fileId:string,
    mimeType:string,
    fileName:string
}
export interface CreateAudience {
    name: string,
    applicationId: string,
    audienceGroups: CreateAudienceGroup[]
}
export enum AudienceGroupType {
    AND = 'AND',
    OR = 'OR'
}
export enum AudienceFilterType {
    STR_EQUALS = 'STR_EQUALS',
    STR_STARTS_WITH = 'STR_STARTS_WITH',
    STR_ENDS_WITH = 'STR_ENDS_WITH',
    STR_CONTAINS = 'STR_CONTAINS',
    STR_DOES_NOT_EQUAL = 'STR_DOES_NOT_EQUAL',
    STR_IS_ONE_OF = 'STR_IS_ONE_OF',
    STR_IS_NOT_ONE_OF = 'STR_IS_NOT_ONE_OF',
    NUM_EQUAL_TO = 'NUM_EQUAL_TO',
    NUM_NOT_EQUAL_TO = 'NUM_NOT_EQUAL_TO',
    NUM_GREATER_THAN = 'NUM_GREATER_THAN',
    NUM_GREATER_THAN_OR_EQUAL_TO = 'NUM_GREATER_THAN_OR_EQUAL_TO',
    NUM_LESS_THAN = 'NUM_LESS_THAN',
    NUM_LESS_THAN_OR_EQUAL = 'NUM_LESS_THAN_OR_EQUAL',
    BOOL_IS_TRUE = 'BOOL_IS_TRUE',
    BOOL_IS_FALSE = 'BOOL_IS_FALSE'
}

export interface CreateAudienceGroup {
    type: AudienceGroupType
    filters: CreateAudienceGroupFilter[]
}

export interface CreateAudienceGroupFilter {
    type: AudienceFilterType,
    fieldName: string,
    string_value?: string,
    num_value?:number,
    fileName?:string,
    file_dataUri?:string|UploadFile
}